import { Link as RemixLink } from "@remix-run/react";
import { FooterT } from "./links";

export const FooterLinkComp = ({ title, links }: { title: string; links: Array<FooterT> }) => {
  return (
    <div>
      <h2 className="mb-2 text-base md:text-lg font-bold text-gray-900 dark:text-white">{title}</h2>
      <ul
        className="text-gray-500 dark:text-gray-400 font-medium"
        aria-label={`Links related to ${title}`}
      >
        {links.map((link) => {
          return (
            <li className="mb-1" key={link.name}>
              <RemixLink
                to={link.pathname}
                prefetch="intent"
                aria-label={`Navigate to ${link.name}`}
                className="hover:underline text-gray dark:text-gray-100 text-xs font-normal"
              >
                {link.name}
              </RemixLink>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
